export const getBiasedGroupProbabilities = (biased_groups, group_probabilities, additional_bias) => {
  // this should be the same as the function on the BE
  let _probabilities = JSON.parse(JSON.stringify(group_probabilities));
  if (biased_groups.length < Object.keys(group_probabilities).length) {
    let accumulated_probability = 0;
    for (let g in _probabilities) {
      if (biased_groups.includes(g)) {
        let modified_probability = _probabilities[g] + _probabilities[g] * additional_bias;
        accumulated_probability += modified_probability;
        _probabilities[g] = modified_probability;
      }
    }
    let probability_left = 100 - accumulated_probability;
    let reduced_probability = Math.round(
      probability_left / (Object.keys(group_probabilities).length - biased_groups.length) * 100
    ) / 100;
    reduced_probability = Math.max(0, reduced_probability);

    for (let g in _probabilities) {
      if (!biased_groups.includes(g)) {
        _probabilities[g] = reduced_probability;
      }
    }
  }
  return _probabilities;
};


export const getAdditionalBiasExample = (additional_bias) => {
  if (additional_bias === undefined || !additional_bias) {
    return '';
  }
  let biasedGroups = ['a'];
  let probabilities = {'a': 50, 'b': 50};
  let biasedProbabilities = getBiasedGroupProbabilities(biasedGroups, probabilities, additional_bias);
  return JSON.stringify(biasedProbabilities);
};


// WEBPACK FOOTER //
// ./src/utils/utilFunctions.js